
import React from "react";
import Card from "../component/Card"


const Showcase = () => (
  <div className="menucontent mx-auto">
    <ul className="flex-container flex-wrap flex-justify-between karya">
      <Card image="https://rencanamu.id/assets/file_uploaded/blog/1486430755-skilledup.jpg"/>
      <Card image="https://qwords.com/blog/wp-content/uploads/2021/01/Cara-Menggunakan-Canva-Untuk-Desain-Menarik.jpg"/>
      <Card image="https://rencanamu.id/assets/file_uploaded/blog/1486430755-skilledup.jpg"/>
      <Card image="https://qwords.com/blog/wp-content/uploads/2021/01/Cara-Menggunakan-Canva-Untuk-Desain-Menarik.jpg"/>
      <Card image="https://rencanamu.id/assets/file_uploaded/blog/1486430755-skilledup.jpg"/>
      <Card image="https://qwords.com/blog/wp-content/uploads/2021/01/Cara-Menggunakan-Canva-Untuk-Desain-Menarik.jpg"/>
    </ul>
  </div>
)

export default Showcase; 